import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ContentfulImage from './components/ContentfulImage/ContentfulImage';

const BlogSlideComponent = ({ link, title, image }) => (
  <div
    className={classNames(
      'block float-left w-full !text-gray no-underline hover:!no-underline focus-visible:rounded-[5px] focus-visible:p-[5px] focus-visible:outline-offset-[-2px]',
      'flex-[1_1] flex-col box-content justify-between items-center min-w-[80%] sm:min-w-[33.333%] lg:min-w-[25%] px-2.5',
      '[&_img]:object-cover [&_img]:block [&_img]:aspect-square'
    )}
  >
    <Link
      to={link}
      className="block focus-visible:rounded-[5px] focus-visible:mb-[5px] focus-visible:p-[5px] focus-visible:outline-offset-[-2px]"
    >
      <ContentfulImage alt="" src={image} width={480} height={260} />
      <p className="text-lg font-bold">{title}</p>
    </Link>
  </div>
);

BlogSlideComponent.propTypes = {
  image: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default BlogSlideComponent;
